export default __webpack_public_path__ + "static/alison-11e63cdade75896627f8f775145a1090.png";